import React, { useState, useEffect } from 'react';
import {
    DialogTitle, DialogContent, DialogActions, Dialog, makeStyles, Paper, ClickAwayListener, MenuList, MenuItem, Card, CardContent, Divider,
    Popper,
    Grow,
    Button,
    IconButton,
    Grid,
    InputAdornment
} from '@material-ui/core';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import DateFnsUtils from '@date-io/date-fns';
import CloseIcon from '@material-ui/icons/Close';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';


const useStyles = makeStyles((theme) => ({
    marginV2: {
        marginTop: 16
    },
    title: {
        color: '#9ea0a5',
        fontSize: 12
    },
    marginV1: {
        marginTop: 8
    },
    paper2: {
        borderRadius: 6,
    },
    paperWidth: {
        maxWidth: 460
    },
    dialogTitleV1: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 12,
        paddingBottom: 12,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    divV1: {
        fontWeight: 300,
        fontSize: 20
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    marginV3: {
        marginTop: 28
    },
    da1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        letterSpacing: '1px',
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    eventIcon: {
        color: 'grey'
    }
}));

const CustomDateFilterDialog = ({ open, onClose, vehicle, user, onConfirm }) => {

    let submit;
    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Start Date*</div>
                            <DatePicker
                                disableFuture
                                name="startDate"
                                margin="none"
                                variant="inline"
                                fullWidth={true}
                                // onChange={(date) => { setTripStartDate(date) }}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                placeholder="Select Start Date"
                                dateFunsUtils={DateFnsUtils}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>End Date*</div>
                            <DatePicker
                                disableFuture
                                name="endDate"
                                margin="none"
                                variant="inline"
                                fullWidth={true}
                                minDate={values.startDate}
                                // onChange={(date) => { setTripStartDate(date) }}
                                inputVariant="outlined"
                                size="small"
                                format="dd-MM-yyyy"
                                placeholder="Select End Date"
                                dateFunsUtils={DateFnsUtils}
                                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const validate = async values => {

        const errors = {}

        if (!values.startDate) {
            errors.startDate = "Please select Start Date";
        }

        if (!values.endDate) {
            errors.endDate = "Please select End Date";
        }

        return errors;

    }

    const onSubmit = values => {

        const startDate = values.startDate ? values.startDate.setHours(0, 0, 0, 0) / 1000 : "";
        const endDate = values.endDate ? values.endDate.setHours(23, 59, 59, 59) / 1000 : "";

        var dateRange = {
            startTimeEpoch: startDate ? Number(Math.round(startDate)) : "",
            endTimeEpoch: endDate ? Number(Math.round(endDate)) : ""
        }

        onConfirm(dateRange);

    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    return (
        <>
            <Dialog fullWidth={true}
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper2, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV1}>Custom Date Filter</div>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        // initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                    {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button className={classes.confirmV1} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default CustomDateFilterDialog;